module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-75.f8d904f7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-75.png
// module id = 3293
// module chunks = 11